/* istanbul ignore file */
import React from 'react'

import { Box, CircularProgress } from '@mui/material'

export default () => (
  <Box className="center-all" data-testid="aroya-route-loading" overflow="hidden">
    <CircularProgress color="primary" />
  </Box>
)
